import React, {PropsWithChildren} from 'react';

import {useLocation} from '@reach/router';

import {Box} from '@mui/material';

import SnackbarProvider from '../shared/components/Snackbar';
import {RegexProvider, AuthProvider} from '../shared/contexts';

import {AppProviderLayout} from './AppProviderLayout';
import {LoginpageProviderLayout} from './LoginpageProviderLayout';

/** Routen, die das AppProviderLayout (authentifizierte Benutzer) benötigen. */
const APP_ROUTES = [
  '/start',
  '/bibliothek',
  '/benutzer',
  '/bildbearbeitung',
  '/import',
  '/swagger',
];

/** Routen, die das LoginpageProviderLayout (öffentliche Seiten) benötigen. */
const LOGIN_ROUTES = [
  '/',
  '/impressum',
  '/kontakt',
  '/datenschutzbestimmung',
  '/nutzungsbedingungen',
  '/neues-passwort',
  '/nu',
  '/pw',
  '/zugang-beantragen',
];

const BaseProvider: React.FC<PropsWithChildren> = ({children}) => {
  return (
    <Box>
      <RegexProvider>
        <SnackbarProvider>
          <AuthProvider>
            <BaseLayout>{children}</BaseLayout>
          </AuthProvider>
        </SnackbarProvider>
      </RegexProvider>
    </Box>
  );
};

const BaseLayout: React.FC<PropsWithChildren> = ({children}) => {
  const {pathname} = useLocation();
  const normalizedPath = pathname.endsWith('/')
    ? pathname.slice(0, -1) || '/'
    : pathname;

  if (APP_ROUTES.some(route => normalizedPath.startsWith(route))) {
    return <AppProviderLayout>{children}</AppProviderLayout>;
  }
  if (LOGIN_ROUTES.includes(normalizedPath)) {
    return <LoginpageProviderLayout>{children}</LoginpageProviderLayout>;
  }
  // 404 und unbekannte Routen benötigen kein spezifisches Provider-Layout
  return <>{children}</>;
};

export default BaseProvider;
